define('home/views/common/ActivityCardPostBaseView',[
    'backbone',
    'backbone-marionette',

    'home/mixins/withSubviews',

    'home/views/PostActivityCollectionView',
], function (
    Backbone,
    Marionette,

    withSubviews,

    PostActivityCollectionView
) {

    'use strict';

    /**
     * The base view for a card representing a group of activities that are either
     * posts or replies.
     */
    var ActivityCardPostBaseView = Marionette.ItemView.extend({
        regions: {
            postsRegion: '[data-role=posts]',
            footerRegion: '[data-role=footer]',
        },

        /**
         * Builds and returns a view that shows the group of post and reply activities.
         */
        buildPostsView: function () {
            return new PostActivityCollectionView({
                el: this.postsRegion.el,
                collection: new Backbone.Collection(this.model.activities),
            });
        },

        // Subclasses must override this method
        createFooterView: undefined,

        onRender: function () {
            this.activateRegion(this.postsRegion, this.buildPostsView);
            this.activateRegion(this.footerRegion, this.createFooterView);
        },
    });


    withSubviews.call(ActivityCardPostBaseView.prototype);

    return ActivityCardPostBaseView;
});

